var imageThumbnail = require('./image-thumbnail')

module.exports = function(profilePicUrl) {
    if (profilePicUrl) {
        return imageThumbnail(profilePicUrl, { size: '64x' })
    } else {
        return Billy.image('misc/default-user-profile-pic.png')
    }
}
